module.exports = __webpack_public_path__ + "static/media/r4.4d04712c.jpg";